type NavigateFn = (to: string, options?: { replace?: boolean }) => void

let navigateImpl: NavigateFn | null = null

export function setNavigator(fn: NavigateFn | null) {
  navigateImpl = fn
}

export const navigator = {
  go(to: string) {
    if (navigateImpl) navigateImpl(to)
    else window.location.assign(to)
  },
  replace(to: string) {
    if (navigateImpl) navigateImpl(to, { replace: true })
    else window.location.replace(to)
  },
}
